export default __webpack_public_path__ + "static/media/congratulation.fc68e089.gif";